import Header from './Header.vue';
import Menu from './Menu.vue';

export default {
  Header,
  Menu,
};
